// extracted by mini-css-extract-plugin
export var Inner = "SecondScreen-module--Inner--9FyJR";
export var AllContent = "SecondScreen-module--AllContent--0NNE4";
export var SectionTitle = "SecondScreen-module--SectionTitle---SaIk";
export var Title = "SecondScreen-module--Title--547uz";
export var arrowLeft = "SecondScreen-module--arrowLeft--hUjUk";
export var arrowRight = "SecondScreen-module--arrowRight--eh8+w";